import React, { Fragment, useEffect } from "react";
import { Switch, Redirect } from "react-router-dom";

import RootRouter from "./Router/RootRouter";
import AppLayout from "./Layout/AppLayout";
import ExamLayout from "./Layout/ExamLayout";
import AuthLayout from "./Layout/AuthLayout";
import Home from "./components/Home/Home";
import Register from "./components/Auth/Register";
import ActivateAccount from "./components/ActivateAccount";
import Login from "./components/Auth/Login";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";
import ForceChangePassword from "./components/Auth/ForceChangePassword";

import Calculator from "./components/Calculator/Calculator";

import CmsPage from "./components/cms/CmsPage";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";

import AdminLayout from "./Layout/Admin/AdminLayout";
import AdminLogin from "./components/Admin/Auth/AdminLogin";
import AdminForgotPassword from "./components/Admin/Auth/AdminForgotPassword";
import AdminResetPassword from "./components/Admin/Auth/AdminResetPassword";

import HomeSetting from "./components/Admin/HomeSettings/HomeSetting";

import ListBanners from "./components/Admin/Banners/ListBanners";
import AddBanner from "./components/Admin/Banners/AddBanner";
import EditBanner from "./components/Admin/Banners/EditBanner";

import AdminDashboard from "./components/Admin/Dashboard/AdminDashboard";
import AdminLoginLayout from "./Layout/Admin/AdminLoginLayout";
import Dashboard from "./components/Dashboard/Dashboard";
import UserLayout from "./Layout/UserLayout";
import Profile from "./components/User/Profile";
import EditProfile from "./components/User/EditProfile";
import UpdatePassword from "./components/User/UpdatePassword";
import ListUser from "./components/Admin/Users/AdminUsers/ListUser";
import EditAdminUser from "./components/Admin/Users/AdminUsers/EditAdminUser";
import AddAdminUser from "./components/Admin/Users/AdminUsers/AddAdminUser";
import AssignRole from "./components/Admin/Users/AdminUsers/AssignRole";

import ListStudents from "./components/Admin/Users/Students/ListStudents";
import EditStudent from "./components/Admin/Users/Students/EditStudent";
import AddStudent from "./components/Admin/Users/Students/AddStudent";
import ImportStudents from "./components/Admin/Users/Students/ImportStudents";

import ListSchools from "./components/Admin/Schools/ListSchools";
import ListSchoolPayments from "./components/Admin/Schools/ListSchoolPayments";
import ListSchoolSlotPackages from "./components/Admin/Schools/ListSchoolSlotPackages";
import ListSchoolSlotPurchases from "./components/Admin/Schools/ListSchoolSlotPurchases";

import ListCms from "./components/Admin/cms/ListCms";
import EditCms from "./components/Admin/cms/EditCms";

import ListEmailTemplates from "./components/Admin/EmailTemplates/ListEmailTemplates";
import EditEmailTemplate from "./components/Admin/EmailTemplates/EditEmailTemplate";

import ListCategories from "./components/Admin/Categories/ListCategories";
import AddCategory from "./components/Admin/Categories/AddCategory";
import EditCategory from "./components/Admin/Categories/EditCategory";

import ListExams from "./components/Admin/Exams/ListExams";
import AddExam from "./components/Admin/Exams/AddExam";
import EditExam from "./components/Admin/Exams/EditExam";

import ListUniversity from "./components/Admin/University/ListUniversity";
import AddUniversity from "./components/Admin/University/AddUniversity";
import EditUniversity from "./components/Admin/University/EditUniversity";

import ListSubscriptions from "./components/Admin/Subscriptions/ListSubscriptions";
import AddSubscription from "./components/Admin/Subscriptions/AddSubscription";
import EditSubscription from "./components/Admin/Subscriptions/EditSubscription";
import PaidUsersReport from "./components/Admin/Reports/PaidUsersReport";
import RevenueReport from "./components/Admin/Reports/RevenueReport";
import ConversionReport from "./components/Admin/Reports/ConversionReport";
import RetentionReport from "./components/Admin/Reports/RetentionReport";
import ListDiscounts from "./components/Admin/Discounts/ListDiscounts";
import AddDiscount from "./components/Admin/Discounts/AddDiscount";
import EditDiscount from "./components/Admin/Discounts/EditDiscount";
import CurrencySettings from "./components/Admin/CurrencySettings/CurrencySettings";

import ListAssessments from "./components/Admin/Assessments/ListAssessments";
import AddAssessment from "./components/Admin/Assessments/AddAssessment";
import EditAssessment from "./components/Admin/Assessments/EditAssessment";

import ListCourses from "./components/Admin/Courses/ListCourses";
import AddCourse from "./components/Admin/Courses/AddCourse";
import EditCourse from "./components/Admin/Courses/EditCourse";

import ListSubjects from "./components/Admin/Subjects/ListSubjects";
import AddSubject from "./components/Admin/Subjects/AddSubject";
import EditSubject from "./components/Admin/Subjects/EditSubject";

import ListTopics from "./components/Admin/Topics/ListTopics";
import AddTopic from "./components/Admin/Topics/AddTopic";
import EditTopic from "./components/Admin/Topics/EditTopic";

import ListQuestionSubjects from "./components/Admin/Questions/ListQuestionSubjects";
import QuestionBankSearch from "./components/Admin/Questions/QuestionBankSearch";
import AddQuestionSubject from "./components/Admin/Questions/AddQuestionSubject";
import ListSubjectYears from "./components/Admin/Questions/ListSubjectYears";
import EditSubjectYear from "./components/Admin/Questions/EditSubjectYear";

import ListTopicSections from "./components/Admin/TopicSections/ListTopicSections";
import AddTopicSection from "./components/Admin/TopicSections/AddTopicSection";
import EditTopicSection from "./components/Admin/TopicSections/EditTopicSection";
import ListQuestionTopicSections from "./components/Admin/Questions/ListQuestionTopicSections";

import ListQuestions from "./components/Admin/Questions/ListQuestions";
import AddQuestion from "./components/Admin/Questions/AddQuestion";
import EditQuestion from "./components/Admin/Questions/EditQuestion";
import ImportQuestions from "./components/Admin/Questions/ImportQuestions";

import ListTheories from "./components/Admin/Theories/ListTheories";
import AddTheory from "./components/Admin/Theories/AddTheory";
import EditTheory from "./components/Admin/Theories/EditTheory";

import ListNews from "./components/Admin/News/ListNews";
import AddNews from "./components/Admin/News/AddNews";
import EditNews from "./components/Admin/News/EditNews";

import Page404 from "./components/Page404";
import Exams from "./components/Exam/Exams";
import ExamSubscriptions from "./components/Subscription/ExamSubscriptions";
import Categories from "./components/Categories/Categories";
import CategoryCourses from "./components/CategoryCourses/CategoryCourses";
import CourseSubjects from "./components/CourseSubjects/CourseSubjects";
import Assessment from "./components/Assessment/Assessment";
import Instruction from "./components/Mock/Instruction";
import DemoExam from "./components/Demo/DemoExam";
import DemoQuiz from "./components/Demo/DemoQuiz";
import DemoResult from "./components/Demo/DemoResult";

import News from "./components/News/News";
import NewsDetail from "./components/News/NewsDetail";
import UserSubscriptions from "./components/Subscription/UserSubscriptions";
import RegisteredSubjects from "./components/RegisteredSubjects/RegisteredSubjects";
import AdminRegSubjects from "./components/Admin/RegisteredSubjects/RegisteredSubjects";
import SelectSubjectTopic from "./components/RegisteredSubjects/SelectSubjectTopic";
import YearQuestions from "./components/Questions/YearQuestions";
import Results from "./components/Results/Results";
import ListResults from "./components/Results/ListResults";
import ResultView from "./components/Results/ResultView";
import ListUserSubscriptions from "./components/Admin/UserSubscriptions/ListUserSubscriptions";
import AddStudentSubscription from "./components/Admin/UserSubscriptions/AddStudentSubscription";
import ListAdvices from "./components/Admin/Advices/ListAdvices";
import AddAdvice from "./components/Admin/Advices/AddAdvice";
import EditAdvice from "./components/Admin/Advices/EditAdvice";

import ListInstructions from "./components/Admin/Instructions/ListInstructions";
import AddInstruction from "./components/Admin/Instructions/AddInstruction";
import EditInstruction from "./components/Admin/Instructions/EditInstruction";

import ListContactus from "./components/Admin/Contactus/ListContactus";
import ContactusDetail from "./components/Admin/Contactus/ContactusDetail";
import ContactUsFront from "./components/Contactus/ContactUsFront";

import ListImageNotifications from "./components/Admin/ImageNotification/ListImageNotifications";
import AddImageNotification from "./components/Admin/ImageNotification/AddImageNotification";
import EditImageNotification from "./components/Admin/ImageNotification/EditImageNotification";

import ListSubscribeNewsletter from "./components/Admin/SubscribeNewsletter/ListSubscribeNewsletter";
import ListSurveys from "./components/Admin/Surveys/ListSurveys";
import SurveyDetail from "./components/Admin/Surveys/SurveyDetail";
import EmailCampaign from "./components/Admin/Campaigns/EmailCampaign";
import ListUserTheories from "./components/Admin/UserTheories/ListUserTheories";
import StartMock from "./components/Mock/StartMock";
import MockExam from "./components/Mock/MockExam";
import StartExam from "./components/Mock/StartExam";
import SavedSubjects from "./components/SavedSubjects/SavedSubjects";
import ExamType from "./components/ExamTypes/ExamType";
import TheoriesQuestions from "./components/Questions/TheoriesQuestions";
import ObjectiveQuestions from "./components/Questions/ObjectiveQuestions";
import ObjectiveExam from "./components/Mock/ObjectiveExam";
import TheoriesExam from "./components/Mock/TheoriesExam";
import TheoriesGrade from "./components/Results/TheoriesGrade";
import TheoriesResults from "./components/Results/TheoriesResults";
import TheoriesResultView from "./components/Results/TheoriesResultView";
import ListTestimonials from "./components/Admin/Testimonials/ListTestimonials";
import AddTestimonial from "./components/Admin/Testimonials/AddTestimonial";
import EditTestimonial from "./components/Admin/Testimonials/EditTestimonial";
import PerformanceTracker from "./components/Results/PerformanceTracker";
import SavedExamSubjects from "./components/SavedSubjects/SavedExamSubjects";
import UpdateSubjects from "./components/Admin/RegisteredSubjects/UpdateSubjects";
import UpdateExamSubjects from "./components/SavedSubjects/UpdateExamSubjects";
import University from "./components/University/University";
import PlanSubscriptions from "./components/Subscription/PlanSubscriptions";

// FAQ Components
import FAQs from "./components/FAQ/FAQs";
import ListFAQs from "./components/Admin/FAQ/ListFAQs";
import NewFAQ from "./components/Admin/FAQ/NewFAQ";
import EditFAQ from "./components/Admin/FAQ/EditFAQ";

// Role Management Components
import ListRoles from "./components/Admin/Roles/ListRoles";
import AddRole from "./components/Admin/Roles/AddRole";
import EditRole from "./components/Admin/Roles/EditRole";

// Permission enforcement
import { withPermission } from "./components/Admin/Includes/PermissionRoute";
import { PERMISSIONS } from "./utils/permissions";

// Welcome/Landing page redirect component
const WelcomeRedirect = () => {
  useEffect(() => {
    const landingUrl = process.env.REACT_APP_LANDING_URL || "http://localhost:3000";
    window.location.href = landingUrl;
  }, []);
  return null;
};

const AppRouter = () => {
  return (
    <Fragment>
      <Switch>
        <RootRouter
          exact
          path="/"
          layout={AppLayout}
          component={WelcomeRedirect}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/home"
          layout={AppLayout}
          component={Home}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/exams"
          layout={AppLayout}
          component={Exams}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/university"
          layout={AppLayout}
          component={University}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/exam-type"
          layout={AppLayout}
          component={ExamType}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/categories"
          layout={AppLayout}
          component={Categories}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/category-courses"
          layout={AppLayout}
          component={CategoryCourses}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/subscription"
          layout={AppLayout}
          component={ExamSubscriptions}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/subscription-plans"
          layout={AppLayout}
          component={PlanSubscriptions}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/course-subjects"
          layout={AppLayout}
          component={CourseSubjects}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/mode-of-assessment"
          layout={AppLayout}
          component={Assessment}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/registered-subjects"
          layout={AppLayout}
          component={RegisteredSubjects}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/select-subject-topic"
          layout={AppLayout}
          component={SelectSubjectTopic}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/instructions"
          layout={AppLayout}
          component={Instruction}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/start-exam"
          layout={AppLayout}
          component={StartExam}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/start-mock/:id"
          layout={AppLayout}
          component={StartMock}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/mock-exam/:id"
          layout={ExamLayout}
          component={MockExam}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/demo"
          layout={AppLayout}
          component={DemoExam}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/demo/quiz"
          layout={ExamLayout}
          component={DemoQuiz}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/demo/result"
          layout={AppLayout}
          component={DemoResult}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/news"
          layout={AppLayout}
          component={News}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/news/:id"
          layout={AppLayout}
          component={NewsDetail}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/register"
          layout={AuthLayout}
          component={require('./components/Auth/RegisterNew').default}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/register-legacy"
          layout={AuthLayout}
          component={Register}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/login"
          layout={AuthLayout}
          component={Login}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/forgot-password"
          layout={AuthLayout}
          component={ForgotPassword}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/force-change-password"
          layout={AuthLayout}
          component={ForceChangePassword}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/password/reset/:token"
          layout={AuthLayout}
          component={ResetPassword}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/contact-us"
          layout={AuthLayout}
          component={ContactUsFront}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/terms-and-conditions"
          layout={AppLayout}
          component={TermsAndConditions}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/privacy-policy"
          layout={AppLayout}
          component={PrivacyPolicy}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/pages/:page_url"
          layout={AppLayout}
          component={CmsPage}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/dashboard"
          layout={UserLayout}
          component={Dashboard}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/profile"
          layout={UserLayout}
          component={Profile}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/profile/edit"
          layout={UserLayout}
          component={EditProfile}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/account-setting"
          layout={UserLayout}
          component={UpdatePassword}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/list-questions"
          layout={ExamLayout}
          component={YearQuestions}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/objective-questions"
          layout={ExamLayout}
          component={ObjectiveQuestions}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/theories-questions"
          layout={ExamLayout}
          component={TheoriesQuestions}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/objective-exam/:id"
          layout={ExamLayout}
          component={ObjectiveExam}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/theories-grade/:id"
          layout={ExamLayout}
          component={TheoriesGrade}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/theories-exam/:id"
          layout={ExamLayout}
          component={TheoriesExam}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/calculator"
          layout={UserLayout}
          component={Calculator}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/my-subscriptions"
          layout={UserLayout}
          component={UserSubscriptions}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/saved-exams"
          layout={UserLayout}
          component={SavedSubjects}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/saved-subjects"
          layout={UserLayout}
          component={SavedExamSubjects}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/saved-subjects-update"
          layout={UserLayout}
          component={UpdateExamSubjects}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/results"
          layout={UserLayout}
          component={ListResults}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/mock-score"
          layout={UserLayout}
          // component={MockScoreAnalytics}
          component={PerformanceTracker}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/practice-results/:quizId"
          layout={UserLayout}
          component={Results}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/theories-results/:quizId"
          layout={UserLayout}
          component={TheoriesResults}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/practice-results-view/:quizId"
          layout={ExamLayout}
          component={ResultView}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/theories-results-view/:quizId"
          layout={ExamLayout}
          component={TheoriesResultView}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin"
          layout={AdminLayout}
          component={withPermission(AdminDashboard, PERMISSIONS.DASHBOARD_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/users"
          layout={AdminLayout}
          component={withPermission(ListUser, PERMISSIONS.USERS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/users/:id/assign-role"
          layout={AdminLayout}
          component={withPermission(AssignRole, PERMISSIONS.USERS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/users/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditAdminUser, PERMISSIONS.USERS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/users/add"
          layout={AdminLayout}
          component={withPermission(AddAdminUser, PERMISSIONS.USERS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/roles"
          layout={AdminLayout}
          component={withPermission(ListRoles, PERMISSIONS.ROLES_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/roles/add"
          layout={AdminLayout}
          component={withPermission(AddRole, PERMISSIONS.ROLES_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/roles/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditRole, PERMISSIONS.ROLES_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/students"
          layout={AdminLayout}
          component={withPermission(ListStudents, PERMISSIONS.STUDENTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/students/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditStudent, PERMISSIONS.STUDENTS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/students/add"
          layout={AdminLayout}
          component={withPermission(AddStudent, PERMISSIONS.STUDENTS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/students/import"
          layout={AdminLayout}
          component={withPermission(ImportStudents, PERMISSIONS.STUDENTS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/schools"
          layout={AdminLayout}
          component={withPermission(ListSchools, PERMISSIONS.SCHOOLS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/school-payments"
          layout={AdminLayout}
          component={withPermission(ListSchoolPayments, PERMISSIONS.SCHOOLS_PAYMENTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/school-slot-packages"
          layout={AdminLayout}
          component={withPermission(ListSchoolSlotPackages, PERMISSIONS.SCHOOLS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/school-slot-purchases"
          layout={AdminLayout}
          component={withPermission(ListSchoolSlotPurchases, PERMISSIONS.SCHOOLS_PAYMENTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/home-setting"
          layout={AdminLayout}
          component={withPermission(HomeSetting, PERMISSIONS.HOME_SETTING_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/banners"
          layout={AdminLayout}
          component={withPermission(ListBanners, PERMISSIONS.BANNERS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/banners/add"
          layout={AdminLayout}
          component={withPermission(AddBanner, PERMISSIONS.BANNERS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/banners/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditBanner, PERMISSIONS.BANNERS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/pages"
          layout={AdminLayout}
          component={withPermission(ListCms, PERMISSIONS.CMS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/pages/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditCms, PERMISSIONS.CMS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/emailtemplates"
          layout={AdminLayout}
          component={withPermission(ListEmailTemplates, PERMISSIONS.EMAIL_TEMPLATES_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/emailtemplates/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditEmailTemplate, PERMISSIONS.EMAIL_TEMPLATES_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/categories"
          layout={AdminLayout}
          component={withPermission(ListCategories, PERMISSIONS.CATEGORIES_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/categories/add"
          layout={AdminLayout}
          component={withPermission(AddCategory, PERMISSIONS.CATEGORIES_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/categories/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditCategory, PERMISSIONS.CATEGORIES_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/exams"
          layout={AdminLayout}
          component={withPermission(ListExams, PERMISSIONS.EXAMS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/exams/add"
          layout={AdminLayout}
          component={withPermission(AddExam, PERMISSIONS.EXAMS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/exams/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditExam, PERMISSIONS.EXAMS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/university"
          layout={AdminLayout}
          component={withPermission(ListUniversity, PERMISSIONS.UNIVERSITY_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/university/add"
          layout={AdminLayout}
          component={withPermission(AddUniversity, PERMISSIONS.UNIVERSITY_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/university/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditUniversity, PERMISSIONS.UNIVERSITY_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/assessments"
          layout={AdminLayout}
          component={withPermission(ListAssessments, PERMISSIONS.ASSESSMENTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/assessments/add"
          layout={AdminLayout}
          component={withPermission(AddAssessment, PERMISSIONS.ASSESSMENTS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/assessments/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditAssessment, PERMISSIONS.ASSESSMENTS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/courses"
          layout={AdminLayout}
          component={withPermission(ListCourses, PERMISSIONS.COURSES_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/courses/add"
          layout={AdminLayout}
          component={withPermission(AddCourse, PERMISSIONS.COURSES_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/courses/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditCourse, PERMISSIONS.COURSES_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subjects"
          layout={AdminLayout}
          component={withPermission(ListSubjects, PERMISSIONS.SUBJECTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subjects/add"
          layout={AdminLayout}
          component={withPermission(AddSubject, PERMISSIONS.SUBJECTS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subjects/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditSubject, PERMISSIONS.SUBJECTS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/topics/:subjectId"
          layout={AdminLayout}
          component={withPermission(ListTopics, PERMISSIONS.TOPICS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/topics/:subjectId/add"
          layout={AdminLayout}
          component={withPermission(AddTopic, PERMISSIONS.TOPICS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/topics/:subjectId/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditTopic, PERMISSIONS.TOPICS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/topic-sections/:topicId"
          layout={AdminLayout}
          component={withPermission(ListTopicSections, PERMISSIONS.TOPICS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/topic-sections/:topicId/add"
          layout={AdminLayout}
          component={withPermission(AddTopicSection, PERMISSIONS.TOPICS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/topic-sections/edit/:sectionId"
          layout={AdminLayout}
          component={withPermission(EditTopicSection, PERMISSIONS.TOPICS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subscriptions"
          layout={AdminLayout}
          component={withPermission(ListSubscriptions, PERMISSIONS.SUBSCRIPTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subscriptions/add"
          layout={AdminLayout}
          component={withPermission(AddSubscription, PERMISSIONS.SUBSCRIPTIONS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subscriptions/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditSubscription, PERMISSIONS.SUBSCRIPTIONS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/reports/paid-users"
          layout={AdminLayout}
          component={withPermission(PaidUsersReport, PERMISSIONS.REPORTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/reports/revenue"
          layout={AdminLayout}
          component={withPermission(RevenueReport, PERMISSIONS.REPORTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/reports/conversion"
          layout={AdminLayout}
          component={withPermission(ConversionReport, PERMISSIONS.REPORTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/reports/retention"
          layout={AdminLayout}
          component={withPermission(RetentionReport, PERMISSIONS.REPORTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/discounts"
          layout={AdminLayout}
          component={withPermission(ListDiscounts, PERMISSIONS.DISCOUNTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/discounts/add"
          layout={AdminLayout}
          component={withPermission(AddDiscount, PERMISSIONS.DISCOUNTS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/discounts/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditDiscount, PERMISSIONS.DISCOUNTS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/currency-settings"
          layout={AdminLayout}
          component={withPermission(CurrencySettings, PERMISSIONS.CURRENCY_SETTINGS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/student-subscriptions"
          layout={AdminLayout}
          component={withPermission(ListUserSubscriptions, PERMISSIONS.STUDENT_SUBSCRIPTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/student-subscriptions/add"
          layout={AdminLayout}
          component={withPermission(AddStudentSubscription, PERMISSIONS.STUDENT_SUBSCRIPTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/student-registered-subjects"
          layout={AdminLayout}
          component={withPermission(AdminRegSubjects, PERMISSIONS.REGISTERED_SUBJECTS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/student-registered-subjects/update"
          layout={AdminLayout}
          component={withPermission(UpdateSubjects, PERMISSIONS.REGISTERED_SUBJECTS_VIEW)}
          protectedUrl={true}
        />
        student-registered-subjects
        <RootRouter
          exact
          path="/admin/question-subjects"
          layout={AdminLayout}
          component={withPermission(ListQuestionSubjects, PERMISSIONS.QUESTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/question-bank-search"
          layout={AdminLayout}
          component={withPermission(QuestionBankSearch, PERMISSIONS.QUESTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/question-subjects/add"
          layout={AdminLayout}
          component={withPermission(AddQuestionSubject, PERMISSIONS.QUESTIONS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subject-years/:subjectId"
          layout={AdminLayout}
          component={withPermission(ListSubjectYears, PERMISSIONS.QUESTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subject-years/edit/:examId/:subId"
          layout={AdminLayout}
          component={withPermission(EditSubjectYear, PERMISSIONS.QUESTIONS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/topicsection/:subjectId/:id"
          layout={AdminLayout}
          component={withPermission(ListQuestionTopicSections, PERMISSIONS.QUESTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/questions/:sectionId/:subjectId/:yearId/:topicId"
          layout={AdminLayout}
          component={withPermission(ListQuestions, PERMISSIONS.QUESTIONS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/questions/import/:sectionId/:subjectId/:yearId/:topicId"
          layout={AdminLayout}
          component={withPermission(ImportQuestions, PERMISSIONS.QUESTIONS_CREATE)}
          // component={ExcelUploadRenderer}
          protectedUrl={true}
        />
        <RootRouter
          exact
          // path="/admin/questions/add/:subjectId/:yearId/:sectionId"
          path="/admin/questions/add/:subjectId/:yearId/:sectionId/:topicId"
          layout={AdminLayout}
          component={withPermission(AddQuestion, PERMISSIONS.QUESTIONS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/questions/edit/:subjectId/:yearId/:id/:tId"
          layout={AdminLayout}
          component={withPermission(EditQuestion, PERMISSIONS.QUESTIONS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/theories/:sectionId/:subjectId/:yearId"
          layout={AdminLayout}
          component={withPermission(ListTheories, PERMISSIONS.THEORIES_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/theories/:subjectId/:yearId/:sectionId/add"
          layout={AdminLayout}
          component={withPermission(AddTheory, PERMISSIONS.THEORIES_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/theories/edit/:subjectId/:yearId/:id"
          layout={AdminLayout}
          component={withPermission(EditTheory, PERMISSIONS.THEORIES_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/news-list"
          layout={AdminLayout}
          component={withPermission(ListNews, PERMISSIONS.NEWS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/news-list/add"
          layout={AdminLayout}
          component={withPermission(AddNews, PERMISSIONS.NEWS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/news-list/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditNews, PERMISSIONS.NEWS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/advice-list"
          layout={AdminLayout}
          component={withPermission(ListAdvices, PERMISSIONS.ADVICES_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/advice-list/add"
          layout={AdminLayout}
          component={withPermission(AddAdvice, PERMISSIONS.ADVICES_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/advice-list/:id/edit"
          layout={AdminLayout}
          component={withPermission(EditAdvice, PERMISSIONS.ADVICES_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/exam-instructions"
          layout={AdminLayout}
          component={withPermission(ListInstructions, PERMISSIONS.EXAMS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/exam-instructions/add"
          layout={AdminLayout}
          component={withPermission(AddInstruction, PERMISSIONS.EXAMS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/exam-instructions/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditInstruction, PERMISSIONS.EXAMS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/contactus"
          layout={AdminLayout}
          component={withPermission(ListContactus, PERMISSIONS.CONTACTUS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/contactus/detail/:id"
          layout={AdminLayout}
          component={withPermission(ContactusDetail, PERMISSIONS.CONTACTUS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/image-notifications"
          layout={AdminLayout}
          component={withPermission(ListImageNotifications, PERMISSIONS.IMAGE_NOTIFICATION_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/image-notifications/add"
          layout={AdminLayout}
          component={withPermission(AddImageNotification, PERMISSIONS.IMAGE_NOTIFICATION_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/image-notifications/edit/:id"
          layout={AdminLayout}
          component={withPermission(EditImageNotification, PERMISSIONS.IMAGE_NOTIFICATION_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/subscribenewsletter"
          layout={AdminLayout}
          component={withPermission(ListSubscribeNewsletter, PERMISSIONS.NEWSLETTER_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/surveys"
          layout={AdminLayout}
          component={withPermission(ListSurveys, PERMISSIONS.SURVEY_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/surveys/detail/:id"
          layout={AdminLayout}
          component={withPermission(SurveyDetail, PERMISSIONS.SURVEY_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/email-campaign"
          layout={AdminLayout}
          component={withPermission(EmailCampaign, PERMISSIONS.STUDENTS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/testimonials"
          layout={AdminLayout}
          component={withPermission(ListTestimonials, PERMISSIONS.TESTIMONIALS_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/testimonials/add"
          layout={AdminLayout}
          component={withPermission(AddTestimonial, PERMISSIONS.TESTIMONIALS_CREATE)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/testimonials/:id/edit"
          layout={AdminLayout}
          component={withPermission(EditTestimonial, PERMISSIONS.TESTIMONIALS_EDIT)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/user-theories-exam"
          layout={AdminLayout}
          component={withPermission(ListUserTheories, PERMISSIONS.THEORIES_VIEW)}
          protectedUrl={true}
        />
        <RootRouter
          exact
          path="/activate-account/:id"
          layout={AppLayout}
          component={ActivateAccount}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/admin/login"
          layout={AdminLoginLayout}
          component={AdminLogin}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/admin/forgot-password"
          layout={AdminLoginLayout}
          component={AdminForgotPassword}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/admin/reset-password/:token"
          layout={AdminLoginLayout}
          component={AdminResetPassword}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/faqs"
          layout={AppLayout}
          component={FAQs}
          protectedUrl={false}
        />
        <RootRouter
          exact
          path="/admin/faqs"
          layout={AdminLayout}
          component={withPermission(ListFAQs, PERMISSIONS.FAQS_VIEW)}
          protectedUrl={true}
          adminProtectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/faq/new"
          layout={AdminLayout}
          component={withPermission(NewFAQ, PERMISSIONS.FAQS_CREATE)}
          protectedUrl={true}
          adminProtectedUrl={true}
        />
        <RootRouter
          exact
          path="/admin/faq/:id"
          layout={AdminLayout}
          component={withPermission(EditFAQ, PERMISSIONS.FAQS_EDIT)}
          protectedUrl={true}
          adminProtectedUrl={true}
        />
        <RootRouter
          exact
          path="*"
          layout={AppLayout}
          component={Page404}
          protectedUrl={false}
        />
      </Switch>
    </Fragment>
  );
};

export default AppRouter;
